import ContactUs from "../../components/Contactus";

export default function ContactUsPage() { 

  return (
    <ContactUs />
  )
}
